<template>
    <div>
        <fade-down-modal :show="smsshow">
            <div class="smsMsgbox comMsgbox">
                <div class="header">
                    <header-tag title="发送验证码"></header-tag>
                </div>
                <div class="content">
                    <div class="getsmsCode">
                        <input
                            type="text"
                            placeholder="请输入手机验证码"
                            v-model="phone"
                        />
                        <a
                            href="#"
                            @click="getsmsCode"
                            style="margin-right:10px;"
                        >
                            <span v-show="time == 0">获取短信验证码</span>
                            <span v-show="time != 0">
                                <b style="font-weight: 400;" v-text="time"></b>
                                <b style="font-weight: 400;">秒</b>
                            </span>
                        </a>
                    </div>
                    <div class="tips">
                        验证频繁？推荐在<a href="#" @click.prevent="goHref()"
                            >账号安全</a
                        >中开启手机短信验证，使你的操作便捷安全！
                    </div>
                </div>
                <div><img src="@/assets/img/icon/u207.png" alt="" /></div>
                <div class="btn">
                    <div class="left">
                        <div
                            class="wrong"
                            v-text="wrongMsg"
                            ref="wrongMsg"
                        ></div>
                    </div>
                    <div class="right">
                        <a href="#" class="blue-btn" @click.prevent="_confirm()"
                            >确认</a
                        >
                        <a
                            href="#"
                            class="default-btn"
                            @click.prevent="_cancel()"
                            >取消</a
                        >
                    </div>
                </div>
            </div>
        </fade-down-modal>
    </div>
</template>

<script>
// 头部tag内容
import HeaderTag from "_c/tagTitle/headerTag";
import { mapState, mapActions } from "vuex";
import FadeDownModal from "_c/modals/fadeDown";
import { getsmscode } from "@/requests/emplyee";
import http from "@/utils/http";
export default {
    name: "emplyeeModals",
    components: {
        HeaderTag,
        FadeDownModal
    },
    data() {
        return {
            smstext: "",
            smsshow: false,
            smsError: "",
            phone: "",
            wrongMsg: "",
            time: "",
            errorxinxi: "",
            smsData: "",
            successFn: ""
        };
    },
    computed: {
        ...mapState({
            showOrHide: state => state.emplyee.showOrHide
        })
    },
    watch: {
        show() {
            if (this.show) {
                this.phone = "";
                this.wrongMsg = "";
            }
        },
        smsError() {
            if (this.smsError) {
                this.setWrongMsg(this.smsError);
            }
            return this.smsError;
        }
    },
    mounted() {
        window.$sms = {};
        // window.$sms.show = (data,fn) => {
        //     this.show(data)
        //     this.successFn = fn
        // }
        window.$sms.show = data => {
            return new Promise(resolve => {
                this.show(data, () => {
                    resolve(true);
                });
            });
        };
    },
    methods: {
        show(data, fn) {
            this.smsshow = true;
            this.smsData = data;
            this.successFn = fn;
        },
        hide() {
            this.smsshow = false;
        },
        ...mapActions(["emplyee/actionSetShowOrHide"]),
        goHref() {
            this.$router.push({
                path: this.$PAGE_API.home.children.accountSafe.path
            });
            this["emplyee/actionSetShowOrHide"](false);
        },
        setWrongMsg(txt) {
            this.wrongMsg = txt;
            this.$domFn.shake(this.$refs.wrongMsg);
        },
        msgCountDown() {
            // 短信验证码倒计时
            let that = this,
                num = 300;
            if (that.time == 0) {
                that.time = num; //配置倒计时的时间
                let msgInterval = setInterval(() => {
                    if (that.time != 0) {
                        that.time = that.time - 1;
                    } else {
                        clearInterval(msgInterval);
                    }
                }, 1000);
            }
        },
        async getsmsCode() {
            let res = await getsmscode();
            if (res.code == 200) {
                this.msgCountDown();
                this.setWrongMsg(res.msg);
            } else {
                this.setWrongMsg(res.msg);
            }
        },
        async _confirm() {
            if (this.phone == "") {
                this.setWrongMsg("验证码不能为空");
                return false;
            }
            this.smsData.data.smsCode = this.phone;
            let res = await http
                .post({
                    url: this.smsData.url,
                    data: this.smsData.data
                })
                .then(res => {
                    return res;
                });
            if (res.code == 200) {
                this.hide();
                this.successFn();
            } else {
                this.setWrongMsg(res.msg);
            }
            // this.$emit("getDxCode",this.phone)
            // if(this.smsError){
            //     this.setWrongMsg(this.smsError)
            // }else{
            //     this.setWrongMsg('')
            // }
        },
        _cancel() {
            this.hide();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
@import "_style/_color.scss";
.smsMsgbox {
    width: 400px;
    height: 210px;
    .content {
        overflow: hidden;
        text-align: left;
        padding-left: 20px;
        margin-right: 5px;
        .getsmsCode {
            margin: 10px 0;
            input {
                width: 200px;
                height: 30px;
                border: 1px solid rgba(230, 230, 230, 1);
                padding-left: 5px;
            }
            a {
                width: 100px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                border: 1px solid $blue;
                margin-left: 20px;
                color: $blue;
            }
        }
        .tips {
            color: #a1a1a1;
            a {
                color: $blue;
                text-decoration: underline;
            }
        }
    }
}
.btn {
    margin: 0;
    .left {
        height: 30px;
        width: 130px;
        margin-left: 20px;
        .wrong {
            height: 100%;
            width: 100%;
            // line-height: 30px;
            text-align: left;
            color: $red;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
        }
    }
}
</style>
